import { publicPaths } from './route-paths'

export const compactPublicPages = [
  publicPaths.about,
  publicPaths.userAgreements,
  publicPaths.privacy,
  publicPaths.cookies,
  publicPaths.mitLicenseTerms,
  publicPaths.contact,
  publicPaths.partners,
] as const
